import { FC, useState } from "react";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";

import AddButton from "@/components/AddButton";
import { SrOnly } from "@/components/Layout/Parts";
import { Table, TableContent, Th } from "@/components/Table";
import ToggableHeading from "@/components/ToggableHeading";
import ActorsTableRow from "./ActorsTableRow";
import { AddButtonHolder } from "./Notes";
import ActorsModal from "./ActorsModal";
import { ProductionSceneActorResource } from "@/types/resources";

const StyledTable = styled(Table)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayscale};
  th,
  td {
    font-size: 11px;
    vertical-align: top;
    &:nth-child(1) {
      width: calc(30% - 56px);
      padding-left: 24px;
    }
    &:nth-child(2),
    &:nth-child(4) {
      width: 24%;
    }
    &:nth-child(3) {
      width: 22%;
    }
    &:last-child {
      width: 56px;
      position: relative;
      padding-right: 16px;
    }
  }
  td {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
  }
`;

const TableHolder = styled.div`
  margin-bottom: 56px;
`;

interface Props {
  actors: ProductionSceneActorResource[][];
  scenes: number[];
}

const ActorsTable: FC<Props> = ({ actors, scenes }) => {
  const [isOpen, setIsOpen] = useState(true);

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ToggableHeading
        heading="ACTORS & CRAFTERS"
        onToggle={() => setIsOpen((prev) => !prev)}
        isOpen={isOpen}
      />
      {isOpen && (
        <TableHolder>
          <StyledTable $fixed>
            <thead>
              <tr>
                <Th>Scene Number & Role</Th>
                <Th>Assignee</Th>
                <Th>Start date & time</Th>
                <Th>Note</Th>
                <Th>
                  <SrOnly>Actions</SrOnly>
                </Th>
              </tr>
            </thead>
            <tbody>
              <TableContent
                isLoading={false}
                colSpan={6}
                isError={false}
                hasData={true}
              >
                {actors.map((sceneActors, index) =>
                  sceneActors.map((actor) => (
                    <ActorsTableRow
                      key={actor.id}
                      sceneIndex={index + 1}
                      actor={actor}
                    />
                  ))
                )}
              </TableContent>
            </tbody>
          </StyledTable>
          <AddButtonHolder>
            <AddButton onClick={() => setShowModal(true)}>
              Add actors & crafters
            </AddButton>
          </AddButtonHolder>
          <AnimatePresence>
            {!!showModal && (
              <ActorsModal
                scenes={scenes}
                onClose={() => setShowModal(false)}
              />
            )}
          </AnimatePresence>
        </TableHolder>
      )}
    </>
  );
};

export default ActorsTable;
